export const formPageFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Name: 'name',
  Status__c: 'status',
  Type__c: 'type',
  Comments__c: 'comments',
  Data__c: 'data',
  Copy_of__c: 'copyOf',
  Origin__c: 'origin',
  Title_Translation__c: 'titleTranslation',
  Holds_Reusable_Elements__c: 'holdsReusableElements'
}

export interface FormPage {
  id: string
  titleTranslationId: string
  copyOfId?: string
  originId?: string
  status?: string
  type?: string
  comments?: string
  data: string
  name: string
  titleTranslation?: string
  holdsReusableElements?: boolean
  origin?: string
  objectsConnected?: Record<string, string>
}
